import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";

import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../../components/GovGrMaterialTable";
import { Visibility } from "@material-ui/icons";
import dayjs from "dayjs";
import { fetchApplicationsForCitizen } from "../../../services/applicationsService";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { useHistory } from "react-router-dom";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
});

const ApplicationsForPortAuth = ({ portAuthId }) => {
  const { t } = useLocale();
  const [selectedItem, setSelectedItem] = useState({});
  let history = useHistory();
  const { data, isError, isLoading, refetch } = useQuery(
    ["applicationsForCitizen", portAuthId],
    () => fetchApplicationsForCitizen(portAuthId)
  );
  const classes = useStyles();

  useEffect(() => {
    refetch();
  }, [portAuthId]);

  return (
    <>
      <CustomAlert
        open={isError}
        close={() => {
          refetch();
        }}
        message={t("A network error occured, please try again later")}
      />

      <CustomTable
        isLoading={isLoading}
        columns={[
          {
            title: t("mitroo_lnameA"),
            field: "lname_afora",
            // width: "100px",
          },
          {
            title: t("AFM"),
            field: "afm_ait",
            width: "100px",
          },
          {
            title: t("Protocol Number"),
            field: "reg_num",
            width: "100px",
          },
          {
            title: t("Application date"),
            field: "appl_dt",
            render: (rowData) => (
              <span>{dayjs(rowData.appl_dt).format("DD/MM/YYYY")}</span>
            ),
          },
          {
            // title: t("Surname"),
            title: t("mitroo_lnameΕ"),
            field: "lname_ait",
          },
          {
            title: t("Name"),
            field: "fname_ait",
          },
          {
            title: t("Email Address"),
            field: "email_ait",
          },
          {
            title: t("Application Kind"),
            field: "applicationKind",
          },
          {
            title: t("Application Status"),
            field: "applicationStatus",
          },
        ]}
        data={data}
        onEdit={(event, rowData) => {
          setSelectedItem(rowData);
          history.push("/editApplications/application", {
            id: rowData.id,
            viewOnly: true,
          });
        }}
        editLabel={t("Edit")}
        options={{
          showTitle: false,
        }}
      />
    </>
  );
};

export default ApplicationsForPortAuth;
